import { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router';
import { fetchPermissionToken } from '../services/auth.service';
import { LoginForm } from '@vindr/ui';
import { setCookie } from './setCookie';

function OAuthRoutes({
  oauth,
  routerBasename,
  userAuthenticationService,
}) {

  const getAuthorizationHeader = () => {
    const user = userAuthenticationService.getUser();
    let headers = {};
    if (user?.permission_token) {
      headers = { ...headers, Authorization: `Bearer ${user.permission_token}` };

      //? Add token to cookie
      setCookie('TOKEN', user?.permission_token, 1, '/');
    }
    if (user?.relatedInfo) {
      headers['X-PARAMS'] = user?.relatedInfo;
    }
    if (user?.accessKey) {
      headers = { ...headers, 'X-SHARE-ACCESS-KEY': user?.accessKey };
    }
    if (user?.studyInstanceUID) {
      headers = { ...headers, 'X-SHARE-STUDY-INSTANCE-UID': user?.studyInstanceUID };
    }
    if (user?.passCode) {
      headers = { ...headers, 'X-SHARE-PWD': user?.passCode };
    }

    return headers;
  };

  const handleUnauthenticated = () => {
    // return null because this is used in a react component
    return null;
  };

  const navigate = useNavigate();

  //for multi-tab logout
  useEffect(() => {
    localStorage.removeItem('signoutEvent');
    const storageEventListener = event => {
      const signOutEvent = localStorage.getItem('signoutEvent');
      if (signOutEvent) {
        navigate(
          `/logout?redirect_uri=${encodeURIComponent(window.location.href)}`
        );
      }
    };

    window.addEventListener('storage', storageEventListener);

    return () => {
      window.removeEventListener('storage', storageEventListener);
    };
  }, []);

  useEffect(() => {
    userAuthenticationService.set({ enabled: true });

    userAuthenticationService.setServiceImplementation({
      getAuthorizationHeader,
      handleUnauthenticated,
    });
  }, []);

  return (
    <Routes basename={routerBasename}>
      <Route
        path="/login"
        element={
          <LoginForm
            onSuccess={user => {
              const authUrl = oauth[0].authority + '/protocol/openid-connect/token';
              fetchPermissionToken(user.access_token, authUrl).then(res => {
                userAuthenticationService.setUser({ ...user, permission_token: res?.access_token });


                userAuthenticationService.setUser(user);
                const getAuthorizationHeader = () => {
                  const user = userAuthenticationService.getUser();
                  let headers = {};
                  if (user.permission_token) {
                    headers = { ...headers, Authorization: `Bearer ${user.permission_token}` };
                  }
                  if (user?.relatedInfo) {
                    headers['X-PARAMS'] = user?.relatedInfo;
                  }
                  if (user?.accessKey) {
                    headers = { ...headers, 'X-SHARE-ACCESS-KEY': user?.accessKey };
                  }
                  if (user?.studyInstanceUID) {
                    headers = { ...headers, 'X-SHARE-STUDY-INSTANCE-UID': user?.studyInstanceUID };
                  }
                  if (user?.passCode) {
                    headers = { ...headers, 'X-SHARE-PWD': user?.passCode };
                  }

                  return headers;
                };
                userAuthenticationService.getAuthorizationHeader = getAuthorizationHeader;

                const redirectUri = sessionStorage.getItem('ohif-redirect-to');
                if (redirectUri) {
                  window.location.href = redirectUri;
                } else {
                  window.location.href = '/';
                }
              })

            }}
            oauth={oauth[0]}
          />
        }
      />
    </Routes>
  );
}

export default OAuthRoutes;
